import commandEngine from './CommandEngine';
import { openOutputMsgDlg } from '../../../../../Widgets/OutputMsgWidget/UI/OutputMsgDlg/OutputMsgDlg.jsx';

/**
 * Registers the /output command with the CommandEngine.
 * /output -> opens the shared OutputMsgDlg (debug output log, BE notifications), owner 'global'.
 */
export function registerOutputCommand() {
    commandEngine.register('/output', {
        hint: 'Open output log (debug + notifications)',
        params: [],
        handler: () => openOutputMsgDlg(),
    });
}
